module.exports = __webpack_public_path__ + "04_mole.bbff94fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/04_mole.png
// module id = aCg7
// module chunks = 0